import api from "./api";

// Flag de rollout do boleto via API (config.cfgboletoapiativo no backend).
// Memoiza a promessa para não refazer a chamada a cada GeraCobrancas renderizado.
let _cache;

export function getBoletoApiAtivo() {
  if (!_cache) {
    _cache = api
      .get("pagamentos/configcobranca")
      .then((r) => Boolean(r.data && r.data.boletoApiAtivo))
      .catch(() => false);
  }
  return _cache;
}
